import { Suspense } from "react";
import { Slot } from "expo-router";

import { LoadingScreen } from "~/components/blocks";
import { MetricsLayout } from "~/components/layout/layout";

export default function Layout() {
  return (
    <MetricsLayout>
      <Suspense fallback={<LoadingScreen height={"100dvh"} width={"100%"} />}>
        <Slot />
      </Suspense>
    </MetricsLayout>
  );
}
